var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTuttiRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.29 16.2201H21.88",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.41 16.2201H5.62001C4.45001 16.2201 3.51001 17.1701 3.51001 18.3301V20.9101C3.51001 22.0801 4.46001 23.0201 5.62001 23.0201H44.41C45.58 23.0201 46.52 22.0701 46.52 20.9101V18.3301C46.52 17.1601 45.57 16.2201 44.41 16.2201H36.04",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6401 27.0901L40.2101 40.8701C40.0101 42.0001 39.0301 42.8201 37.8901 42.8201H12.1801C11.0401 42.8201 10.0601 42.0001 9.86005 40.8701L7.43005 27.0901",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.03 29.15V36.61",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.58 29.1901L16.98 36.5701",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.48 29.1901L33.08 36.5701",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.58 18.2101L23.29 4.82007",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.59 18.2101L26.88 4.82007",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTuttiRed);
export default __webpack_public_path__ + "static/media/ic_tutti_red.dfb777f1ebcf565be03773ad4ff89491.svg";
export { ForwardRef as ReactComponent };